import React from "react";
import { usePublicDocuments } from "./hooks/usePublicDocuments";
import PublicDocumentList from "./components/PublicDocumentList";

const PublicDocumentListApp: React.FC = () => {
  const { documents, loading, error } = usePublicDocuments();

  if (loading) {
    return (
      <div className="text-center p-3" role="status">
        <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
        <span className="visually-hidden">Loading documents…</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center text-muted p-3">
        Unable to load documents. Please try again later.
      </div>
    );
  }

  if (documents.length === 0) {
    return null;
  }

  return <PublicDocumentList documents={documents} showTitle />;
};

export default PublicDocumentListApp;
